import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SubCompanyList from './components/SubCompanies/SubCompanyList';
import analytics, * as trackingTypes from '../../actions/analyticsActions';

class ProfileSettingsUI extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        match: PropTypes.shape({
            params: PropTypes.shape({
                id: PropTypes.string.isRequired,
            }).isRequired,
        }).isRequired,
    };

    componentDidMount() {
        const { id } = this.props.match.params;
        this.props.dispatch(analytics(trackingTypes.VIEW_SETTINGS, { id }));
    }

    render() {
        const profileId = parseInt(this.props.match.params.id);
        return (
            <div className="panel">
                <h1>Innstillinger</h1>
                <SubCompanyList profileId={profileId} />
            </div>
        );
    }
}

export default connect()(ProfileSettingsUI);
